export default __webpack_public_path__ + "53a2f75fc2acd349e4c267354fe2846c.png";